import CoreFactory from './core_factory'
export default CoreFactory
